const CYCLE_EXCEPTIONS = {
  restart: [$localize`34 Hour Restart`, $localize`24 Hour Restart` ],
  restBreak: [$localize`30 Minute Rest Break Required`, $localize`No Rest Break Required`],
  waitTime: [$localize`No Waiting Time Exception`, $localize`Waiting Time on 5th Line`],
  shortHaul: [$localize`No Short Haul Exception`, $localize`16 Hour Short Haul Exception`],
  shortHaulDistance: [
    $localize`150 Air-Mile Exception`, $localize`100 Air-Mile Exception`,
    $localize`CDL Required Driver`, $localize`Non-CDL Driver`,
  ],
  farmSchoolBus: [$localize`No Exception`, $localize`16 Hour Shift Exception`],
  adverseDriving: [$localize`Not Available`, $localize`Available`],
};

export { CYCLE_EXCEPTIONS };
